import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-depots',
    templateUrl: './depots.component.html',
    styleUrls: ['./depots.component.css'],
    standalone: false
})
export class DepotsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
